import Link from 'next/link';
import { ArrowSmRightIcon } from '@heroicons/react/solid';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

export function AuthAtEdge() {
  return (
    <div className="mx-auto max-w-7xl overflow-hidden px-4 sm:px-6">
      <div className="lg:grid lg:grid-cols-12 lg:gap-8">
        <div className="sm:text-center md:mx-auto md:max-w-2xl lg:col-span-6 lg:text-left">
          <h2>
            <span className="mt-1 block text-4xl font-extrabold tracking-tight sm:text-5xl xl:text-6xl">
              <span className="block text-gray-900">Purpose built for the</span>
              <span className="block text-clerk-blue">Next.js App Router</span>
            </span>
          </h2>
          <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
            Auth middleware and first-class support for React Server Components
            provide secure page protection and easy access to user and session
            context within server components, actions, and route handlers.
          </p>
          <div>
            <Link legacyBehavior href="/docs/quickstarts/nextjs">
              <a className="relative top-px my-12 block rounded-md border-clerk-blue py-3 text-center font-medium text-clerk-blue transition-all duration-300 hover:scale-105 hover:text-blue-700 md:my-3 md:w-full lg:float-left lg:w-auto">
                Get started with Next.js{' '}
                <ArrowSmRightIcon className="mb-px inline h-6 w-6" />
              </a>
            </Link>
          </div>
        </div>
        <div className="relative mt-12 sm:mx-auto sm:max-w-lg lg:col-span-6 lg:mx-0 lg:mt-0 lg:flex lg:max-w-none lg:items-center">
          <div className="relative mx-auto w-full rounded-lg shadow-lg lg:max-w-md">
            <button
              type="button"
              className="relative block w-full overflow-hidden rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-clerk-blue focus:ring-offset-2"
            >
              <span className="sr-only">Watch our video to learn more</span>
              <LiteYouTubeEmbed id="pawPv5gmLik" title="embedded video" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
